import { cva } from 'class-variance-authority';

export const gridColumnVariants = cva('grid size-full gap-1 overflow-hidden', {
	variants: {
		width: {
			default: 'lg:grid-cols-2',
			wide: 'lg:grid-cols-[1fr_384px]',
			full: 'lg:grid-cols-1'
		},
		singleImage: {
			true: '!grid-cols-1'
		}
	},
	defaultVariants: {
		width: 'default'
	}
});
